import { renderToStaticMarkup } from "react-dom/server";
import styled from "styled-components";
import { currentUserSelector } from "redux/selectors";
import { useSelector } from "react-redux";

import { ReactComponent as ArcIcon } from 'assets/svg/arc.svg';
import { ReactComponent as SuccessArt } from 'assets/svg/onboarding_success-art.svg';

export default function Success() {
  const currentUser = useSelector(currentUserSelector);
  const svgString = encodeURIComponent(renderToStaticMarkup(<ArcIcon />));
  return (
    <Container style={{
      backgroundImage: `url('data:image/svg+xml;utf8, ${svgString}')`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'left center'
    }}>
      <SuccessArt style={{ maxWidth: 287, maxHeight: 230 }} />
      <h4>Nice job, {currentUser?.employee?.first_name}!</h4>
      <br />
      <p>You’ve complete self onboarding process in <br /><b>{currentUser?.company.name}</b></p>
      <br /> <br />
      <p>Your information will be reviewed by the company admin.<br />After that, you'll be able to manage your employee profile.</p>
    </Container>
  )
};

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #F8F8F7;

  & > p {
    & > b {
        font-family: 'Aspira Wide Demi';
    }
    font-size: 18px;
    color: #676767;
    text-align: center;
  }

  & > h4 {
    font-size: 33px;
    color: #676767;
    font-family: 'Aspira Wide Demi';
    margin-top: 25px;
  }
`;